import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import  { PopupColumnsEditorView } from "./popupColumnsEditor-view"

export class PopupColumnsEditorViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.columns = ObservableArray.create<column>();
    }
    GetDefaultView(): View <ViewModel> {
        return new PopupColumnsEditorView();
    }
    public getTypeId(): string {
        return "VM-4CEF5B67-35DE-4AD9-ACC6-59F8ADDECD04"
    }
    
    public set columns(v: ObservableArray<column>) { this._columns = v; } public get columns(): ObservableArray<column> { return this._columns;} private _columns: ObservableArray<column>;
    
    addColumn(){
        let c = new column(this);
        c.index = this.columns.length +1;
        this.columns.push(c);
    }
    removeColumn(column:column){
        this.columns.remove(column);
    }
    
    closePopup(result?: any) {
    }
    
    loadColumns(value: string) {
        this.columns.clear();
        if(stringIsNullOrEmpty(value)){
            return;
        }
        let json = JSON.parse(value);
        this.columns.update(...json.map(x=>{
            let c = new column(this);
            c.index = x.index;
            c.title = x.title;
            c.fieldName = x.fieldName;
            c.typeSelector.selectById(x.type);
            return c;
        }))
    }

    updateIndices(column:column){
        this.columns.forEach(x=>{
            if(x.index>=column.index && x!=column){
                x.index = x.index +1;
            }
        });
        this.columns.sort((x,y)=>(x.index-y.index));
        this.columns.forEach((x,i)=>{
            x.index = i+1;
        })
    }
    confirm(){
        this.columns.sort((x,y)=>(x.index-y.index));
        let result = JSON.stringify(this.columns.map(x=>{
            return {
                index : x.index,
                title : x.title,
                fieldName : x.fieldName,
                type : x.typeSelector.selectedItem.id
            }
        }));
        this.closePopup(result);
    }
    back(){
        this.closePopup();
    }
}

export class column extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PopupColumnsEditorViewModel) {
        super(parent);
        this.typedParent = parent;
        this.typeSelector = new typeSelector(this);
    }
    private typedParent: PopupColumnsEditorViewModel;

    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set fieldName(v: string) { this._fieldName = v; } public get fieldName(): string { return this._fieldName;} private _fieldName: string;
    public set typeSelector(v: typeSelector) { this._typeSelector = v; } public get typeSelector(): typeSelector { return this._typeSelector;} private _typeSelector: typeSelector;

    updateIndices(){
        this.typedParent.updateIndices(this);
    }
    remove(){
        this.typedParent.removeColumn(this);
    }
}

export class typeSelector extends SelectorBaseViewModel<idName>{
    protected loadData(): Promise<idName[]> {
        return Promise.resolve([
            new idName(this,'stringcolumn','string'),
            new idName(this,'numbercolumn','number'),
            new idName(this,'enumcolumn','enum'),
            new idName(this,'boolcolumn','bool'),
            new idName(this,'datecolumn','date')
        ]);
    }

}
export class idName extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,id:string,name:string) {
        super(parent);
        this.id = id;
        this.title = name;
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
}